import { useMutation } from '@tanstack/react-query';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';
import { updateMIPLoanDefinitionData } from '@dealstack/frontend/shared/dataExchange/services/mip.service';
import { LoanDefinitionDto } from '@dealstack/shared/lib/generated';

export const useUpdateLoan = ({ onSuccess }: { onSuccess?: () => void }) => {
	const tMipManage = useTranslationMipManage();

	return useMutation({
		mutationFn: (
			data: LoanDefinitionDto & {
				loanDefinitionId: string;
			}
		) =>
			updateMIPLoanDefinitionData({
				loanDefinitionId: data.loanDefinitionId,
				body: {
					type: data.type,
					name: data.name,
					funderPersonId: data.funderPersonId,
					funderPersonNameToCreate: data.funderPersonNameToCreate,
					mipId: data.mipId,
				},
			}),
		onSuccess: () => {
			showToastV2({
				state: 'success',
				message: tMipManage('root.loans.toast.updated_successfully'),
			});
			onSuccess?.();
		},
		onError: () => {
			showToastV2({
				state: 'error',
				message: tMipManage('root.loans.toast.update_failed'),
			});
		},
	});
};
